import styled from 'styled-components';

export const ConfirmDeleteJobPopupStyle = styled.div`
  strong {
    color: ${({ theme }) => theme.palette.primary};
  }
`;
